import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonitorSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1423_6149)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.23441 13.707L13.8532 13.707C14.4396 13.707 14.915 13.2316 14.915 12.6452L14.915 5.21203C14.915 4.62557 14.4396 4.15016 13.8532 4.15016L3.23441 4.15016C2.64796 4.15016 2.17254 4.62557 2.17254 5.21203L2.17254 12.6452C2.17254 13.2316 2.64796 13.707 3.23441 13.707Z",
			stroke: "black",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M10.6674 15.832H6.41992",
			stroke: "black",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1423_6149",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.99,
			height: 16.99,
			fill: "white",
			transform: "translate(0.0488281 0.964844)"
		})
	}) })]
});
export default SvgMonitorSymbol;
